module.exports = __webpack_public_path__ + "4c8ec24cf5deedfbd8403a104b2e4c88.png";